import { useCallback, useEffect, useMemo } from 'react';

import { UploadFileByQrLinkParamKey } from '@/common/constants';
import { useSearchParams } from '@/modules/transaction/hooks/useSearchParams';

const useUploadFileByQrLinkParams = () => {
  const { query: qrIdFromParams } = useSearchParams(UploadFileByQrLinkParamKey.QR_ID);
  const { query: employeeIdFromParams } = useSearchParams(UploadFileByQrLinkParamKey.EMPLOYEE_ID);
  const { query: validToFromParams } = useSearchParams(UploadFileByQrLinkParamKey.VALID_TO);
  const { query: docIdFromParams } = useSearchParams(UploadFileByQrLinkParamKey.DOCUMENT_ID);
  const { query: docTypeFromParams } = useSearchParams(UploadFileByQrLinkParamKey.DOCUMENT_TYPE);

  const isNewQrCode = useMemo(() => {
    const qrIdFromStorage = localStorage.getItem(UploadFileByQrLinkParamKey.QR_ID);
    return qrIdFromStorage && qrIdFromParams && qrIdFromStorage !== qrIdFromParams;
  }, [qrIdFromParams]);

  const handleResetStorage = useCallback(() => {
    localStorage.removeItem(UploadFileByQrLinkParamKey.QR_ID);
    localStorage.removeItem(UploadFileByQrLinkParamKey.EMPLOYEE_ID);
    localStorage.removeItem(UploadFileByQrLinkParamKey.VALID_TO);
    localStorage.removeItem(UploadFileByQrLinkParamKey.DOCUMENT_ID);
    localStorage.removeItem(UploadFileByQrLinkParamKey.DOCUMENT_TYPE);
  }, []);

  useEffect(() => {
    if (isNewQrCode) {
      handleResetStorage();
    }
    if (qrIdFromParams) {
      localStorage.setItem(UploadFileByQrLinkParamKey.QR_ID, qrIdFromParams);
    }
    if (employeeIdFromParams) {
      localStorage.setItem(UploadFileByQrLinkParamKey.EMPLOYEE_ID, employeeIdFromParams);
    }
    if (validToFromParams) {
      localStorage.setItem(UploadFileByQrLinkParamKey.VALID_TO, validToFromParams);
    }
    if (docIdFromParams) {
      localStorage.setItem(UploadFileByQrLinkParamKey.DOCUMENT_ID, docIdFromParams);
    }
    if (docTypeFromParams) {
      localStorage.setItem(UploadFileByQrLinkParamKey.DOCUMENT_TYPE, docTypeFromParams);
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return {
    qrId: isNewQrCode ? qrIdFromParams : qrIdFromParams || localStorage.getItem(UploadFileByQrLinkParamKey.QR_ID),
    employeeId: isNewQrCode ? employeeIdFromParams : employeeIdFromParams || localStorage.getItem(UploadFileByQrLinkParamKey.EMPLOYEE_ID),
    validTo: isNewQrCode ? validToFromParams : validToFromParams || localStorage.getItem(UploadFileByQrLinkParamKey.VALID_TO),
    docId: isNewQrCode ? docIdFromParams : docIdFromParams || localStorage.getItem(UploadFileByQrLinkParamKey.DOCUMENT_ID),
    docType: isNewQrCode ? docTypeFromParams : docTypeFromParams || localStorage.getItem(UploadFileByQrLinkParamKey.DOCUMENT_TYPE),
    handleResetStorage,
  };
};

export default useUploadFileByQrLinkParams;
